import React, { memo, useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useDropzone } from "react-dropzone";
import { useErrorFile, useAcceptedFile } from "@/utils/utils.js";

const DropFile = ({
	acceptFileType = {"application/vnd.openxmlformats-officedocument.spreadsheetml.sheet": [ '.xlsx' ]},
	setDroppedFiles,
	droppedFiles,
	textBrowse = '',
	textDragFiles = '',
	apiError,
	setApiError,
	disabled = false,
}) => {
	const [ error, setError ] = useState();
	const { browse, dragFiles } = useSelector(state => state.app.dict.users.modalLoad);

	const getErrorFile = useErrorFile();
	const getAcceptedFile = useAcceptedFile();

	const { acceptedFiles, fileRejections, getRootProps, getInputProps } = useDropzone({
		accept: acceptFileType,
		multiple: false,
		disabled: disabled,
	});

	useEffect(() => {
		if(acceptedFiles.length > 0) {
			setDroppedFiles(acceptedFiles);
			setApiError(null);
		}
	}, [ acceptedFiles ]);

	useEffect(() => {
		if(fileRejections.length > 0) {
			const err = fileRejections.map(f => f.errors.map(e => getErrorFile(e.code)));
			setDroppedFiles(null);
			setApiError(null);
			setError(err[0]);
		} else {
			setError('');
		}
		
	}, [ fileRejections ]);

	return (
		<div { ...getRootProps({ className: `addletter__dropzone${disabled ? ' disabled' : ''}` }) }>
			<input { ...getInputProps() } />
			<p><span>{textBrowse || browse}</span> {textDragFiles || dragFiles}</p>
			{(droppedFiles && droppedFiles.length > 0) && getAcceptedFile(droppedFiles)}
			{(error || apiError) && <p className="modal__load-dictionary--error">
				{error || apiError}
			</p>}
		</div>
	);
};

export default memo(DropFile);